// Import Packages
import React, { useEffect, useState } from 'react';

// Import Material UI Elements
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { IconButton } from '@material-ui/core';

// Import Pages
import ColumnSelection from './ColumnSelection/ColumnSelection';
import RowSelection from './RowSelection/RowSelection';
import CellSelection from './CellSelection/CellSelection';
import RangeSelection from './RangeSelection/RangeSelection';

function DataTablePreview({ v, type, dataTableValue, setDataTableValue, changeDataTableZoom, size }) {
    const [startDown, setStartDown] = useState(false);

    const captureDown = (e, i) => {
        if (e.ctrlKey) {
            addDataTable(i);
        } else {
            setDataTableValue([i]);
        }
        setStartDown(true)
    }

    const captureOver = (i) => {
        // take action if mouse is held down
        if (startDown) {
            if (type === 'string-range') {
                calculateRange(i);
            } else if (dataTableValue[dataTableValue.length - 1] !== i && dataTableValue.indexOf(i) !== -1) {
                let copyData = [...dataTableValue];
                copyData.splice(dataTableValue.length - 1, 1)
                setDataTableValue(copyData);
            } else {
                addDataTable(i);
            }
        }
    }

    const addDataTable = (v) => {
        let copyData = [...dataTableValue];
        const i = copyData.indexOf(v)
        if (i === -1) {
            copyData.push(v);
            setDataTableValue(copyData);
        } else if (dataTableValue[dataTableValue.length - 1] !== v) {
            copyData.splice(i, 1)
            setDataTableValue(copyData);
        }
    }

    const calculateRange = (lastCell) => {
        // ex lastCell: 1-5
        const start = dataTableValue[0].split('-');
        const startRow = parseInt(start[0]);
        const startCol = parseInt(start[1]);

        const last = lastCell.split('-');
        const endRow = parseInt(last[0]);
        const endCol = parseInt(last[1]);

        let d = [];
        // Loop through all the rows in the table
        for (var row = startRow; (startRow <= endRow ? row <= endRow : row >= endRow); startRow <= endRow ? row++ : row--) {
            // Loop through all the cells in the row
            for (var col = startCol; startCol <= endCol ? col <= endCol : col >= endCol; startCol <= endCol ? col++ : col--) {
                // Add a the current cell
                d.push(`${row.toString()}-${col.toString()}`)
            }
        }
        setDataTableValue(d);
    }

    const captureUp = (i) => {
        if (type === 'string-columns' || type === 'string-rows' || type === 'string-range') {
            setStartDown(false)
        }
    }

    const renderByType = () => {
        switch (type) {
            case "string":
                return <CellSelection v={v} dataTableValue={dataTableValue} setDataTableValue={setDataTableValue}
                    size={size} />
            case "string-single-row":
            case "string-rows":
                return <RowSelection v={v} type={type} dataTableValue={dataTableValue} setDataTableValue={setDataTableValue} size={size}
                    captureDown={captureDown} captureOver={captureOver} />
            case "string-single-column":
            case "string-columns":
            case "string-col-name":
                return <ColumnSelection v={v} dataTableValue={dataTableValue} setDataTableValue={setDataTableValue}
                    size={size} type={type} captureDown={captureDown} captureOver={captureOver} />
            case "string-range":
                return <RangeSelection v={v} dataTableValue={dataTableValue} setDataTableValue={setDataTableValue}
                    size={size} type={type} captureDown={captureDown} captureOver={captureOver} />
            default:
                break;
        }
    }
    return (
        <div onMouseLeave={captureUp} onMouseUpCapture={captureUp}
            className={`${size === 'large' ? 'full-page-preview-value large-container-padding' : 'field-preview-value medium-container-padding'}
             border-radius-4 data-table-container`}
        >
            <table className={`${size === 'large' ? 'full-page-table' : 'min-page-table'} data-table-table`}>
                {renderByType()}
            </table>
            <IconButton className={`data-table-zoom-button ${size}-zoom-button `} onClick={changeDataTableZoom}>
                <ZoomOutMapIcon className={`data-table-zoom-icon ${size}-zoom-icon`} />
            </IconButton>
        </div >
    )
}

function DataTableSelection({ variables, selectedVariable, setSelectedVariable, setDataTableValue }) {
    const [filteredVariables, setFilteredVariables] = useState([]);


    useEffect(() => {
        setFilteredVariables(variables.filter((x) => x.type === 'data table'));
    }, [variables])

    const handleSetChange = (event) => {
        setSelectedVariable(event.target.value);
        setDataTableValue(undefined);
    }
    return (
        <>

            <div style={{ display: 'flex' }}>
                <FormControl variant="outlined" fullWidth  >
                    <Select
                        style={{ borderRadius: 2, height: 34 }}
                        displayEmpty
                        variant="outlined" value={selectedVariable} onChange={handleSetChange}
                    >
                        <MenuItem style={{ fontSize: 12 }} value=""><em>None</em></MenuItem>
                        {filteredVariables?.length > 0 && JSON.stringify(filteredVariables[0]) !== '{}' ? filteredVariables.map((item, itemI) =>
                            <MenuItem style={{ fontSize: 12 }} key={itemI}
                                value={item.name}>{item.name}</MenuItem>
                        ) :
                            <span />
                            // <MenuItem button onClick={()=>handleOpen()} value="">{t('CONTENT.AUTOMS-LIST.ADD-NEW-VARIABLES')}</MenuItem>
                        }
                    </Select>
                </FormControl>

            </div>
        </>
    )
}

export { DataTablePreview, DataTableSelection };